import request from '@/utils/request';
import { newHost } from '@/global-config';

// eslint-disable-next-line import/prefer-default-export
export function pageQuery(data) {
  return request({
    url: '/depositOrder/pageQuery',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

export function exportOrder(data) {
  return request({
    url: '/depositOrder/export',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

export function queryOrderDetail(data) {
  return request({
    url: '/depositOrder/singleDetailQuery',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

export function refundOrder(data) {
  return request({
    url: '/depositOrder/operateScanPreAuthComplete',
    method: 'post',
    data,
    baseURL: newHost,
  });
}

/**
 * 轮询查询退订结果
 * @params flowId 流水号
 * */
export function getOperateRefundResult(params) {
  return request({
    url: '/depositOrder/getOperateRefundResult',
    method: 'get',
    params,
    baseURL: newHost,
  });
}

/**
 * 刷新订单状态
 * @params flowId 流水号
 * */
export function refreshOrderStatus(params) {
  return request({
    url: '/depositOrder/refresh',
    method: 'get',
    params,
    baseURL: newHost,
  });
}
